(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-cart"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mm-cart]').forEach(function(root){
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-key]');if(!b)return;
      b.disabled=true;
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:parseInt(b.dataset.q,10)})})
        .then(function(){window.location.reload()})
        .catch(function(){window.location.reload()});
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collection"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mm-col]').forEach(function(root){
    var grid=root.querySelector('[data-grid]');
    function panel(o){root.classList.toggle('mm-fopen',o);var t=root.querySelector(o?'[data-close]':'[data-open]');if(t)t.focus()}
    root.querySelector('[data-open]').addEventListener('click',function(){panel(true)});
    root.querySelector('[data-close]').addEventListener('click',function(){panel(false)});
    root.querySelector('[data-veil]').addEventListener('click',function(){panel(false)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&root.classList.contains('mm-fopen'))panel(false)});
    root.querySelectorAll('.mm-views button').forEach(function(b){b.addEventListener('click',function(){
      grid.classList.toggle('is-one',b.dataset.v==='one');
      root.querySelectorAll('.mm-views button').forEach(function(x){x.setAttribute('aria-pressed',x===b)});
    })});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-collections"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mm-arch]').forEach(function(c){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var DELAY=parseInt(c.dataset.delay,10)||2500;
    var items=[].slice.call(c.children),n=items.length;
    if(n<3)return;
    items.forEach(function(el){var k=el.cloneNode(true);k.setAttribute('aria-hidden','true');k.setAttribute('tabindex','-1');c.appendChild(k)});
    c.style.scrollSnapType='none';
    var paused=false,resumeT,anim;
    function step(){var gap=parseFloat(getComputedStyle(c).columnGap)||0;return items[0].getBoundingClientRect().width+gap}
    function glide(to){
      var from=c.scrollLeft,t0=null,d=650;cancelAnimationFrame(anim);
      function f(t){if(t0===null)t0=t;var p=Math.min((t-t0)/d,1),e=p<.5?2*p*p:1-Math.pow(-2*p+2,2)/2;
        c.scrollLeft=from+(to-from)*e;if(p<1&&!paused)anim=requestAnimationFrame(f)}
      anim=requestAnimationFrame(f);
    }
    function pause(){paused=true;clearTimeout(resumeT);cancelAnimationFrame(anim)}
    function resume(){clearTimeout(resumeT);resumeT=setTimeout(function(){paused=false},3000)}
    ['touchstart','pointerdown'].forEach(function(e){c.addEventListener(e,pause,{passive:true})});
    ['touchend','touchcancel','pointerup'].forEach(function(e){c.addEventListener(e,resume,{passive:true})});
    if(window.matchMedia('(hover:hover)').matches){c.addEventListener('mouseenter',pause);c.addEventListener('mouseleave',resume)}
    setInterval(function(){
      if(paused||document.hidden)return;
      var w=step(),i=Math.round(c.scrollLeft/w);
      if(i>=n){c.scrollLeft-=n*w;i-=n}
      glide((i+1)*w);
    },DELAY);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.mm-hero').forEach(function(hero){
    var v=hero.querySelector('video');if(!v)return;
    v.muted=true;v.defaultMuted=true;v.setAttribute('playsinline','');v.playsInline=true;
    var btn=document.createElement('button');btn.type='button';btn.className='mm-playbtn';btn.setAttribute('aria-label','Lancer la vidéo');btn.textContent='▶';btn.hidden=true;
    hero.appendChild(btn);
    function start(){var p=v.play();if(p&&p.then){p.then(function(){btn.hidden=true}).catch(function(){btn.hidden=false;arm()})}}
    function arm(){['touchstart','pointerdown','click','scroll'].forEach(function(e){window.addEventListener(e,function h(){window.removeEventListener(e,h);start()},{once:true,passive:true})})}
    btn.addEventListener('click',start);
    v.addEventListener('playing',function(){btn.hidden=true});
    setTimeout(function(){if(v.paused||v.currentTime===0){btn.hidden=false;arm()}},1200);
    document.addEventListener('visibilitychange',function(){if(!document.hidden&&v.paused)start()});
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product"]) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mm-product]').forEach(function(root){
    var variants=JSON.parse(root.querySelector('[data-variants]').textContent);
    var groups=[].slice.call(root.querySelectorAll('[data-opt]'));
    var idInput=root.querySelector('[data-id]'),hint=root.querySelector('[data-hint]');
    var buy=root.querySelector('[data-buy]'),barBuy=root.querySelector('[data-bar-buy]'),bar=root.querySelector('[data-bar]');
    var priceEl=root.querySelector('[data-price]'),barPrice=root.querySelector('[data-bar-price]'),form=root.querySelector('form');
    var chosen=groups.map(function(){return null});
    var soldOut=buy.disabled;
    function names(){return groups.map(function(g){return g.getAttribute('aria-label').toLowerCase()}).join(' et ')}
    function label(t,ok){[buy,barBuy].forEach(function(b){if(!b)return;b.textContent=t;b.classList.toggle('is-ok',!!ok)})}
    function current(){
      if(!groups.length)return variants[0];
      if(chosen.indexOf(null)>-1)return null;
      return variants.filter(function(v){return v.options.every(function(o,i){return o===chosen[i]})})[0]||null;
    }
    function refresh(){
      groups.forEach(function(g,gi){
        [].forEach.call(g.querySelectorAll('.mm-sz'),function(b){
          b.disabled=!variants.some(function(v){
            return v.available&&v.options[gi]===b.dataset.value&&chosen.every(function(c,ci){return ci===gi||c===null||v.options[ci]===c});
          });
        });
      });
    }
    groups.forEach(function(g,gi){
      g.addEventListener('click',function(e){
        var b=e.target.closest('.mm-sz');if(!b||b.disabled)return;
        [].forEach.call(g.querySelectorAll('.mm-sz'),function(x){x.setAttribute('aria-pressed',x===b)});
        chosen[gi]=b.dataset.value;refresh();
        var v=current();
        hint.className='mm-hint';
        if(v){
          idInput.value=v.id;
          var html=v.price+(v.compare?'<s>'+v.compare+'</s>':'');
          priceEl.innerHTML=html;if(barPrice)barPrice.textContent=v.price;
          hint.textContent=chosen.join(' / ')+' choisi.';
        }
      });
    });
    refresh();
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(soldOut)return;
      var v=current();
      if(!v){
        hint.textContent='Choisis ta '+names()+' pour continuer.';hint.className='mm-hint is-err';
        if(groups[0])groups[0].scrollIntoView({block:'center',behavior:'smooth'});
        return;
      }
      if(!v.available)return;
      idInput.value=v.id;
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok)throw new Error('add');return r.json()})
        .then(function(){
          label('Ajouté ✓',true);
          setTimeout(function(){label('Ajouter au panier',false)},1600);
          return fetch('/cart.js').then(function(r){return r.json()});
        })
        .then(function(cart){
          shipUpdate(cart.total_price);
          document.querySelectorAll('[data-cart-count],.cart-count-bubble span').forEach(function(el){el.textContent=cart.item_count});
          document.dispatchEvent(new CustomEvent('cart:updated',{detail:cart}));
        })
        .catch(function(){form.submit()});
    });
    var ship=root.querySelector('[data-ship]');
    function money(c){return (c/100).toFixed(2).replace('.',',')+' €'}
    function shipUpdate(total){
      if(!ship)return;
      var th=parseFloat(ship.dataset.threshold),t=ship.querySelector('[data-ship-txt]'),b=ship.querySelector('[data-ship-bar]');
      ship.hidden=false;
      if(total>=th){t.textContent='Bravo, la livraison est offerte ✓';b.style.width='100%'}
      else{t.innerHTML='Plus que <b>'+money(th-total)+'</b> pour la livraison offerte';b.style.width=(total/th*100)+'%'}
    }
    if(barBuy)barBuy.addEventListener('click',function(){buy.click()});
    var open=root.querySelector('[data-open-size]'),size=root.querySelector('#mm-d-size');
    if(open&&size)open.addEventListener('click',function(){size.open=true});
    var gal=root.querySelector('[data-gal]'),dots=[].slice.call(root.querySelectorAll('.mm-dots i'));
    if(gal&&dots.length)gal.addEventListener('scroll',function(){
      var w=gal.firstElementChild.getBoundingClientRect().width+8,i=Math.round(gal.scrollLeft/w);
      dots.forEach(function(d,k){d.classList.toggle('on',k===i)});
    },{passive:true});
    if(bar){
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){bar.classList.toggle('is-show',!en[0].isIntersecting&&en[0].boundingClientRect.top<0)}).observe(buy);
      }else{bar.classList.add('is-show')}
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-videos"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mm-vids]').forEach(function(c){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var DELAY=parseInt(c.dataset.delay,10)||1800;
    var items=[].slice.call(c.children),n=items.length;
    if(n<3)return;
    items.forEach(function(el){var k=el.cloneNode(true);k.setAttribute('aria-hidden','true');c.appendChild(k)});
    c.style.scrollSnapType='none';
    var paused=false,resumeT,anim;
    function step(){var gap=parseFloat(getComputedStyle(c).columnGap)||0;return items[0].getBoundingClientRect().width+gap}
    function glide(to){
      var from=c.scrollLeft,t0=null,d=550;cancelAnimationFrame(anim);
      function f(t){if(t0===null)t0=t;var p=Math.min((t-t0)/d,1),e=p<.5?2*p*p:1-Math.pow(-2*p+2,2)/2;
        c.scrollLeft=from+(to-from)*e;if(p<1&&!paused)anim=requestAnimationFrame(f)}
      anim=requestAnimationFrame(f);
    }
    function pause(){paused=true;clearTimeout(resumeT);cancelAnimationFrame(anim)}
    function resume(){clearTimeout(resumeT);resumeT=setTimeout(function(){paused=false},3000)}
    ['touchstart','pointerdown'].forEach(function(e){c.addEventListener(e,pause,{passive:true})});
    ['touchend','touchcancel','pointerup'].forEach(function(e){c.addEventListener(e,resume,{passive:true})});
    if(window.matchMedia('(hover:hover)').matches){c.addEventListener('mouseenter',pause);c.addEventListener('mouseleave',resume)}
    setInterval(function(){
      if(paused||document.hidden)return;
      var w=step(),i=Math.round(c.scrollLeft/w);
      if(i>=n){c.scrollLeft-=n*w;i-=n}
      glide((i+1)*w);
    },DELAY);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
